import {Card, Icon} from '@blueprintjs/core';
import {Link} from 'react-router-dom';

export default function Employee() {
     const menu = [
          {id: 'employee-reconcile', path: '/employee/reconcile', icon: 'applications', title: 'Rekonsiliasi Karyawan'}
          // {id: 'employee-list', path: '/employee/list', icon: 'th-list', title: 'Data Karyawan'},
          // {id: 'employee-mail', path: '/employee/mail', icon: 'envelope', title: 'Notifikasi'}
     ];
     return (
          <div className="content-wrapper">
               <div className="menu-wrapper">
                    {menu.map((e, i) => (
                         <Link key={i} to={e.path}>
                              <Card className="bp5-interactive menu-item">
                                   <Icon size={60} icon={e.icon} />
                                   <br />
                                   <div className="menu-footer">{e.title}</div>
                              </Card>
                         </Link>
                    ))}
               </div>
          </div>
     );
}
